import React, { Component } from 'react'
import { Route } from 'react-router-dom'
// import { AdminElectionResult } from './components/AdminElectionResult'
// import Login from './components/Login'
// import ImportFilePage from './components/ImportFile'
// import { PublicElectionResult } from './components/PublicElectionResult'
// import AdminStatisticsView  from './components/AdminStatistics'
// import AdminDashboard from './components/AdminDashboard'
// import PublicElectionList from './components/PublicElectionList'
// import PublicStatistics from './components/PublicStatistics'
import { LiveAnnouncer } from 'react-aria-live';
import 'semantic-ui-css/semantic.min.css';

import Loadable from 'react-loadable';
import Loading from './components/Loading'

const LoadableLogin = Loadable({
  loader: () => import('./components/Login'),
  loading: Loading,
})

const LoadableImportFile = Loadable({
  loader: () => import('./components/ImportFile'),
  loading: Loading,
})

const LoadableManageRCV = Loadable({
  loader: () => import('./components/ManageRCV'),
  loading: Loading,
})

const LoadableAdminER = Loadable({
  loader: () => import('./components/AdminElectionResult'),
  loading: Loading,
})

const LoadableAdminStats = Loadable({
  loader: () => import('./components/AdminStatistics'),
  loading: Loading,
})

const LoadableAdminDashboard = Loadable({
  loader: () => import('./components/AdminDashboard'),
  loading: Loading,
})

const LoadablePublicER = Loadable({
  loader: () => import('./components/PublicElectionResult'),
  loading: Loading,
})

const LoadablePublicStats = Loadable({
  loader: () => import('./components/PublicStatistics'),
  loading: Loading,
})

const LoadablePublicElectionList = Loadable({
  loader: () => import('./components/PublicElectionList'),
  loading: Loading,
})
  

export default class App extends Component {
  displayName = App.name

  render() {
    return (
      <LiveAnnouncer>
        <Route path='/admin/login' component={LoadableLogin} />
        <Route path='/admin/importdata' component={LoadableImportFile} />
        <Route path='/admin/manageRCV' component={LoadableManageRCV} />
        <Route path='/admin/election_results/:importId?/:dateId?/:slug?' render={ (props) => <LoadableAdminER {...props} key={window.location.href}/>} />
        <Route path='/admin/election_statistics/:importId?/:dateId?/:slug?' component={LoadableAdminStats} />
        <Route path='/admin/dashboard' component={LoadableAdminDashboard} />
        <Route path='/election_results/:resultsId?' component={LoadablePublicER} />
        <Route path='/election_statistics/:resultsId?' component={LoadablePublicStats} />
        <Route exact path='/' component={LoadablePublicElectionList} />
      </LiveAnnouncer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js